import React, {useState} from "react"
import classNames from "classnames"
import FaIcon from "./components/fa_icon"

function PageMenu({
  menuEntries,
  onMenuEntryClicked
}) {
  const [openEntry, setOpenEntry] = useState(null)

  function toggleSubMenu(id) {
    setOpenEntry(openEntry === id ? null : id)
  }

  function onLinkClick(e, id) {
    e.preventDefault()
    onMenuEntryClicked(id)
  }

  return (
    <ul>
      {menuEntries.map((entry) => (
        <MenuEntry
          key={entry.id}
          entry={entry}
          isOpen={openEntry === entry.id}
          toggleSubMenu={toggleSubMenu}
          onLinkClick={onLinkClick}
        />
      ))}
    </ul>
  )
}

function MenuEntry({entry, isOpen, toggleSubMenu, onLinkClick}) {
  return (
    <li className={classNames({opened: isOpen, active: entry.isActive})}>
      <a
        href={`#${entry.id}`}
        onClick={(e) => onLinkClick(e, entry.id)}
      >
        {entry.title}
      </a>
      {!!entry.children?.length && (
        <span className="page-menu-caret">
          &#65279;
          <FaIcon
            key={`${entry.id}_caret_icon`}
            name={isOpen || entry.isActive ? "fa-caret-down" : "fa-caret-right"}
            onClick={() => toggleSubMenu(entry.id)}
          />
        </span>)}
      {!!entry.children?.length && (
        <ul key={`${entry.id}_sub_menu`}>
          {entry.children.map((child) => (
            <MenuEntry
              key={child.id}
              entry={child}
              toggleSubMenu={toggleSubMenu}
              onLinkClick={onLinkClick}
            />
          ))}
        </ul>)}
    </li>
  )
}

export default PageMenu
